'use client';

import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

const SCROLL_RESTORATION_SCOPE_PREFIXES = ['/cars', '/vehicle'];

function isWithinScrollRestorationScope(pathname: string | null): boolean {
  return SCROLL_RESTORATION_SCOPE_PREFIXES.some(prefix =>
    (pathname ?? '').startsWith(prefix)
  );
}

// usePreventScrollRestoration sets history.scrollRestoration = 'manual' on
// SRP without reverting it, so the setting survives an SPA round trip to VDP
// and back. This is the counterpart that reverts it to 'auto' once client-side
// navigation actually leaves the SRP/VDP loop, so the effect doesn't bleed
// into unrelated pages reachable via the same shared layout.
export default function ScrollRestorationScopeGuard() {
  const pathname = usePathname();

  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (window.history.scrollRestoration === 'auto') return;
    if (isWithinScrollRestorationScope(pathname)) return;

    window.history.scrollRestoration = 'auto';
  }, [pathname]);

  return null;
}
